import { popoverAnatomy as s } from "@chakra-ui/anatomy";
import { createMultiStyleConfigHelpers as p, defineStyle as o } from "@chakra-ui/styled-system";
import { cssVar as r } from "@chakra-ui/theme-tools";
const { defineMultiStyleConfig: a, definePartsStyle: i } = p(s.keys), e = r("popper-bg"), n = r("popper-arrow-bg"), t = r("popper-arrow-shadow-color"), l = o({ zIndex: 10 }), d = o({
  [e.variable]: "colors.white",
  bg: e.reference,
  [n.variable]: e.reference,
  [t.variable]: "colors.gray.200",
  _dark: {
    [e.variable]: "colors.gray.700",
    [t.variable]: "colors.whiteAlpha.300"
  },
  width: "xs",
  border: "1px solid",
  borderColor: "inherit",
  borderRadius: "md",
  boxShadow: "sm",
  zIndex: "inherit",
  _focusVisible: {
    outline: 0,
    boxShadow: "outline"
  }
}), b = o({
  px: 3,
  py: 2,
  borderBottomWidth: "1px"
}), c = o({
  px: 3,
  py: 2
}), y = o({
  px: 3,
  py: 2,
  borderTopWidth: "1px"
}), h = o({
  position: "absolute",
  borderRadius: "md",
  top: 1,
  insetEnd: 2,
  padding: 2
}), S = i({
  popper: l,
  content: d,
  header: b,
  body: c,
  footer: y,
  closeButton: h
}), w = a({
  baseStyle: S,
  variants: {
    /**
     * Popover size to content
     * https://github.com/chakra-ui/chakra-ui/issues/2609#issuecomment-737289774
     */
    responsive: {
      popper: {
        maxWidth: "unset",
        width: "inherit"
      }
    }
  }
});
export {
  w as popoverTheme
};
